<template>
    <div class="img-credited">
        <BaseImg
            :src="src"
            :alt="alt"
            :resolve="resolve"
            class="img-credited__image"
        />

        <Credit :credit="credit" />
    </div>
</template>

<script>
export default {
    props: {
        src: String,
        alt: String,
        credit: String,
        resolve: {
            type: Boolean,
            default: false
        },
    }
}
</script>

<style>
.img-credited {
    @apply relative;
}
</style>